import { ChatWorkspaceLayout } from '@/components/chat/ChatWorkspaceLayout'

export function ChatWorkspacePage() {
  return <ChatWorkspaceLayout />
}
